export const CACHE_PATIENT = 'cache/CACHE_PATIENT';
export const SET_ORGANIZATIONS_CACHED = 'cache/SET_ORGANIZATIONS_CACHED';
export const SET_CLIENTS_CACHED = 'cache/SET_CLIENTS_CACHED';
export const CACHE_PORTAL_INVITES = 'cache/CACHE_PORTAL_INVITES';
export const CACHE_PORTAL_RELATION_STATUSES = 'cache/CACHE_PORTAL_RELATION_STATUSES';
export const CACHE_PORTAL_THREADS = 'cache/CACHE_PORTAL_THREADS';
export const CACHE_PORTAL_THREAD_MESSAGES = 'cache/CACHE_PORTAL_THREAD_MESSAGES';
